if (typeof DynaCore_FormConfig_Heading == 'undefined') {
    var DynaCore_FormConfig_Heading =
    {
        partClass: 'el-heading',
        partName: 'heading',
        partSelector: '.el-heading',

        /**
         * Inicializace objektu typu Heading
         */
        init: function () {
            DynaCore_FormConfig_Heading.contextMenuInit();
            DynaCore_FormConfig_Heading.sortableInit();
        },

        contextMenuInit: function () {
            $('#designer')
                .off('contextmenu', DynaCore_FormConfig_Heading.partSelector)
                .on('contextmenu', DynaCore_FormConfig_Heading.partSelector, function (e) {
                    DynaCore_FormConfig_Heading.contextMenuShow(e, this);
                    return false;
                });
        },

        /**
         * Inicializace kontextoveho menu objektu typu Heading
         *
         * @param e
         * @param element
         */
        contextMenuShow: function (e, element) {
            DynaBase_ContextMenu.addHeader(translate('Heading'));

            // Tlacitko - Upravit
            DynaBase_ContextMenu.addButton(translate('Edit'), 'pencil', function () {
                DynaCore_FormConfig_Heading.edit(element);
            });

            DynaBase_ContextMenu.addDivider();
            DynaBase_ContextMenu.addHeader(translate('General'));

            // Tlacitko - Vlastnosti
            DynaBase_ContextMenu.addButton(translate('Properties'), 'toggle-on', function () {
                var storageId = $(element).data('part-id');

                DynaCore_FormConfig_Properties.edit(element, DynaCore_FormConfig_Heading.partName + 's', storageId);
            });

            // Tlacitko - Nastaveni
            DynaBase_ContextMenu.addButton(translate('Settings'), 'cog', function () {
                var storageId = $(element).data('part-id');

                DynaCore_FormConfig_Settings.edit(element, DynaCore_FormConfig_Heading.partName + 's', storageId);
            });

            // Tlacitko - Odstranit
            DynaBase_ContextMenu.addButton(translate('Remove'), 'trash', function () {
                DynaCore_FormConfig_Heading.delete(element);
            });

            // Sestaveni
            DynaBase_ContextMenu.build(e, element);
        },

        /**
         * Inicializace razeni objektu typu Heading
         */
        sortableInit: function () {
            var indexPartOld = 0;
            var indexPartNew = 0;

            $(".el-col").sortable({
                axis: 'y',
                items: DynaCore_FormConfig_Heading.partSelector,
                start: function (e, ui) {

                    // Najdeme si element rodice
                    var parentElement;
                    var cardElement = $(e.target).children('.card');
                    if ($(cardElement).length > 0) {
                        parentElement = $(cardElement).children('.card-body');
                    } else {
                        parentElement = e.target;
                    }

                    // Najdeme index
                    $(parentElement).find(DynaCore_FormConfig_Heading.partSelector).each(function (i, el) {
                        if ($(el).is(ui.item)) {
                            indexPartOld = i;
                        }
                    });
                },
                update: function (e, ui) {

                    // Najdeme si element rodice
                    var parentElement;
                    var cardElement = $(e.target).children('.card');
                    if ($(cardElement).length > 0) {
                        parentElement = $(cardElement).children('.card-body');
                    } else {
                        parentElement = e.target;
                    }

                    // Najdeme index
                    $(parentElement).find(DynaCore_FormConfig_Heading.partSelector).each(function (i, el) {
                        if ($(el).is(ui.item)) {
                            indexPartNew = i;
                        }
                    });

                    var data = {};
                    if (parseInt($(ui.item).data('tab')) >= 0) {
                        data = {
                            _ch: $('#_ch').val(),
                            pa: DynaCore_FormConfig_Heading.partName,
                            r: $(ui.item).data('row'),
                            c: $(ui.item).data('col'),
                            t: $(ui.item).data('tab'),
                            tr: $(ui.item).data('tab-row'),
                            tc: $(ui.item).data('tab-col'),
                            o: indexPartOld,
                            n: indexPartNew
                        };
                    } else {
                        data = {
                            _ch: $('#_ch').val(),
                            pa: DynaCore_FormConfig_Heading.partName,
                            r: $(ui.item).data('row'),
                            c: $(ui.item).data('col'),
                            o: indexPartOld,
                            n: indexPartNew
                        };
                    }

                    $.ajax({
                        type: 'get',
                        url: window.location.href.replace('/form-config/', '/form-config/part-sort/'),
                        data: data,
                        dataType: "json",
                        success: function () {
                            DynaCore_FormConfig.reindex();
                        }
                    });
                }
            });
        },

        /**
         * Pridani objektu typu Heading
         *
         * @param element
         * @param elementParent
         * @returns {boolean}
         */
        add: function (element, elementParent) {
            var indexRow = $(elementParent).data('row');
            var indexCol = $(elementParent).data('col');
            var indexTab = $(elementParent).data('tab');
            var indexTabRow = $(elementParent).data('tab-row');
            var indexTabCol = $(elementParent).data('tab-col');
            var size = 1;
            var hasCard = $(elementParent).children().hasClass('el-col-card');

            if (true == hasCard) {
                elementParent = $(elementParent).children('.el-col-card').children('.card-body');
            }

            var partIndex = $(elementParent).children(DynaCore_FormConfig_Heading.partSelector).length;
            var headingCount = partIndex + 1;

            if (headingCount > 5) {
                Lemo_Alert.addDanger('Column cannot contain more than five headings', 'formConfigTooMuchHeadingsInColumnError');
                return false;
            }

            $.ajax({
                type: 'get',
                url: window.location.href.replace('/form-config/', '/form-config/part-add/'),
                data: {
                    _ch: $('#_ch').val(),
                    pa: DynaCore_FormConfig_Heading.partName,
                    r: indexRow,
                    c: indexCol,
                    t: indexTab,
                    tr: indexTabRow,
                    tc: indexTabCol,
                    paIn: partIndex,
                    s: size
                },
                dataType: "json",
                success: function (data) {
                    var html = '';
                    if (parseInt($(elementParent).data('tab-row')) >= 0) {
                        html += '<h' + size + ' class="el ' + DynaCore_FormConfig_Heading.partClass + '"  data-row="' + indexRow + '" data-col="' + indexCol + '" data-tab="' + indexTab + '" data-tab-row="' + indexTabRow + '" data-tab-col="' + indexTabCol + '" data-part-index="' + data.paIn + '" data-part-id="' + data.paId + '">' + translate('Heading') + ' ' + headingCount + '</h' + size + '>';
                    } else {
                        html += '<h' + size + ' class="el ' + DynaCore_FormConfig_Heading.partClass + '"  data-row="' + indexRow + '" data-col="' + indexCol + '" data-part-index="' + data.paIn + '" data-part-id="' + data.paId + '">' + translate('Heading') + ' ' + headingCount + '</h' + size + '>';
                    }

                    if ($(elementParent).children(DynaCore_FormConfig_Heading.partSelector).length > 0) {
                        $(elementParent).children(DynaCore_FormConfig_Heading.partSelector).last().after(html);
                    } else {
                        $(elementParent).prepend(html);
                    }

                    DynaCore_FormConfig.init();
                }
            });
        },

        /**
         * Upraveni objektu typu Heading
         *
         * @param element
         */
        edit: function (element) {
            var indexRow = $(element).data('row');
            var indexCol = $(element).data('col');
            var indexTab = $(element).data('tab');
            var indexTabRow = $(element).data('tab-row');
            var indexTabCol = $(element).data('tab-col');
            var partId = $(element).data('part-id');
            var partIndex = $(element).data('part-index');
            var url = window.location.href.replace('/form-config/', '/form-config/part-edit/') + '?_ch=' + $('#_ch').val() + '&pa=' + DynaCore_FormConfig_Heading.partName + '&paId=' + partId;

            $(document).load(url, function (form) {
                Lemo_Modal
                    .setId('modal-container-formconfig-heading-edit')
                    .setTitle('Edit heading')
                    .setContent(form)
                    .setSize('large')
                    .addButton('change', '<i class="fas fa-fw fa-check"></i> ' + translate('Change'), 'btn btn-primary', function () {
                        $.ajax({
                            type: 'post',
                            url: url,
                            data: $('#formConfigHeading').find(':input').serialize(),
                            dataType: "json",
                            success: function (data) {
                                var html = '';

                                if (parseInt($(element).data('tab-row')) >= 0) {
                                    html += '<h' + data.size + ' class="el ' + DynaCore_FormConfig_Heading.partClass + '"  data-row="' + indexRow + '" data-col="' + indexCol + '" data-tab="' + indexTab + '" data-tab-row="' + indexTabRow + '" data-tab-col="' + indexTabCol + '" data-part-index="' + partIndex + '" data-part-id="' + partId + '">' + data.text + '</h' + data.size + '>';
                                } else {
                                    html += '<h' + data.size + ' class="el ' + DynaCore_FormConfig_Heading.partClass + '"  data-row="' + indexRow + '" data-col="' + indexCol + '" data-part-index="' + partIndex + '" data-part-id="' + partId + '">' + data.text + '</h' + data.size + '>';
                                }

                                $(element).replaceWith(html);

                                Lemo_Alert.addSuccess('Heading has been successfully updated', 'formConfigHeadingUpdateSuccess');
                                Lemo_Modal.close();
                            },
                            error: function (html) {
                                Lemo_Alert.addDanger('Some form fields are not filled up or not filled correctly', 'formConfigHeadingUpdateError');

                                $('#dialogBody').html(html.responseText);
                            }
                        });
                    })
                    .addButton('cancel', '<i class="fas fa-fw fa-times"></i> ' + translate('Close'), 'btn btn-secondary', function () {
                        Lemo_Modal.close();
                    });

                Lemo_Modal.build();
            });
        },

        /**
         * Smazani objektu typu Heading
         *
         * @param element
         */
        delete: function (element) {
            var indexRow = $(element).data('row');
            var indexCol = $(element).data('col');
            var indexTab = $(element).data('tab');
            var indexTabRow = $(element).data('tab-row');
            var indexTabCol = $(element).data('tab-col');
            var partId = $(element).data('part-id');
            var partIndex = $(element).data('part-index');

            Lemo_Modal
                .setId('modal-container-formconfig-heading-delete')
                .setTitle('Remove heading')
                .setContent('<p class="text">' + translate('Do you really want to remove selected heading?') + '</p>')
                .addButton('remove', '<i class="fas fa-fw fa-trash"></i> ' + translate('Remove'), 'btn btn-danger', function () {
                    $.ajax({
                        type: 'get',
                        url: window.location.href.replace('/form-config/', '/form-config/part-delete/'),
                        data: {
                            _ch: $('#_ch').val(),
                            pa: DynaCore_FormConfig_Heading.partName,
                            r: indexRow,
                            c: indexCol,
                            t: indexTab,
                            tr: indexTabRow,
                            tc: indexTabCol,
                            paIn: partIndex,
                            paId: partId
                        },
                        dataType: "json",
                        success: function () {
                            if ($(element).parent('.card-body').parent(DynaCore_FormConfig_Heading.partSelector + '-card').length > 0) {
                                element = $(element).parent('.card-body').parent(DynaCore_FormConfig_Heading.partSelector + '-card');
                            }

                            $(element).remove();

                            DynaCore_FormConfig.reindex();
                        },
                        complete: function () {
                            Lemo_Modal.close();
                        }
                    });
                })
                .addButton('cancel', '<i class="fas fa-fw fa-times"></i> ' + translate('Close'), 'btn btn-secondary', function () {
                    Lemo_Modal.close();
                });

            Lemo_Modal.build();
        }
    }
}
